/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Filter_ActionInputs */



/**
* | output |
* | --- |
* | "Action needed ({count})" |
*
* @param {Team_Filter_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_filter_action = /** @type {((inputs: Team_Filter_ActionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Filter_ActionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Actie nodig (${i?.count})`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Action requise (${i?.count})`)
	return /** @type {LocalizedString} */ (`Action needed (${i?.count})`)
});